import * as React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import TYPEKIT from "../constants/TYPEKIT";
import { jsx as ___EmotionJSX } from "@emotion/react";
var StripeProvider = _ref => {
  var {
    children,
    stripeKey
  } = _ref;
  if (!stripeKey || !stripeKey.length) {
    console.warn('Stripe API Key cannot be found!');
  }

  // Load stripe SDK asynchronously on initial load *without* including
  // stripe.js globally
  var stripeInstance = loadStripe(stripeKey);
  var STRIPE_OPTIONS = {
    fonts: [{
      cssSrc: TYPEKIT.SP_URL
    }]
  };
  return ___EmotionJSX(Elements, {
    options: STRIPE_OPTIONS,
    stripe: stripeInstance
  }, children);
};
function withStripe(Component, stripeKey) {
  var StripeProviderWrapper = props => ___EmotionJSX(StripeProvider, {
    stripeKey: stripeKey
  }, ___EmotionJSX(Component, props));
  var name = Component.name || Component.displayName;
  StripeProviderWrapper.displayName = "withStripe" + name;
  return StripeProviderWrapper;
}
export { StripeProvider, withStripe };